import { Close } from '@shared/icons';
import { twMerge } from '@shared/themes';

type TagValue = {
  label: string;
  value: string;
};

type TagProps = {
  label: string;
  value?: string;
  onRemove?: ({ value }: { value: string }) => void;
  isDisabled?: boolean;
  className?: string;
};

function Tag({ label, value = label, onRemove, isDisabled = false, className, ...props }: TagProps) {
  const TAG_CLASSES =
    'flex items-center gap-2 py-2 px-4 w-fit paragraph-explanatory-strong select-none rounded-full bg-container-base border border-border text-foreground hover:bg-container-hover hover:border-transparent data-[disabled=true]:cursor-not-allowed data-[disabled=true]:border-none data-[disabled=true]:bg-container/50 data-[disabled=true]:text-foreground/50';

  const handleClick = () => {
    if (isDisabled) return;
    onRemove?.({ value });
  };

  return (
    <span className={twMerge(TAG_CLASSES, className)} data-disabled={isDisabled} {...props}>
      {label}
      <Close className="data-[disabled=false]:cursor-pointer" onClick={handleClick} data-disabled={isDisabled} size="small" />
    </span>
  );
}

export { Tag, type TagValue };
